export default __webpack_public_path__ + "static/media/home-cafe-slider-img03.d69581ef.jpg";